import React from 'react';
import { formatEther } from 'ethers';
import { AppButton } from '../ui/AppButton';

const weiToEth = (wei) => {
  if (!wei || wei === '0') return '0 ETH';
  try {
    return `${Number(formatEther(wei)).toFixed(4)} ETH`;
  } catch {
    return wei;
  }
};

const exportCsv = (transactions) => {
  const header = [
    'date',
    'transaction_type',
    'counterparty',
    'amount_eth',
    'amount_wei',
    'status',
    'transaction_hash',
    'explorer_link',
  ];
  const rows = transactions.map((tx) => [
    new Date(tx.created_at).toISOString(),
    tx.transaction_type,
    tx.counterparty || '',
    weiToEth(tx.amount_wei),
    tx.amount_wei || '',
    tx.status || '',
    tx.transaction_hash || '',
    tx.explorer_link || '',
  ]);
  const csv = [header, ...rows]
    .map((columns) =>
      columns.map((value) => `"${String(value).replaceAll('"', '""')}"`).join(',')
    )
    .join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'data-exchange-transactions.csv';
  link.click();
  URL.revokeObjectURL(url);
};

/**
 * Connected wallet transaction history with CSV export.
 */
export const TxHistory = ({ transactions, loading }) => (
  <section className="panel-card" aria-labelledby="tx-history-title">
    <div className="panel-header">
      <h2 id="tx-history-title">Transaction History</h2>
      <button type="button" onClick={() => exportCsv(transactions || [])} className="px-3 py-1.5 rounded-card-sm text-[12px] font-semibold text-lb-body hover:text-lb-ink hover:bg-black/[0.04] transition-colors focus-ring outline-none">
        Export CSV
      </button>
    </div>

    {loading ? (
      <p>Loading transactions...</p>
    ) : (
      <div className="table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Type</th>
              <th>Counter-party</th>
              <th>Amount (ETH)</th>
              <th>Status</th>
              <th>Explorer</th>
            </tr>
          </thead>
          <tbody>
            {(transactions || []).map((tx) => (
              <tr key={tx.id}>
                <td>{new Date(tx.created_at).toLocaleString()}</td>
                <td>{tx.transaction_type}</td>
                <td>{tx.counterparty || '-'}</td>
                <td>{weiToEth(tx.amount_wei)}</td>
                <td>{tx.status}</td>
                <td>
                  {tx.explorer_link ? (
                    <a href={tx.explorer_link} target="_blank" rel="noreferrer">
                      View
                    </a>
                  ) : (
                    '-'
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </section>
);
